import Dropzone from 'dropzone';
import { DirectUpload } from '@rails/activestorage';
import { getMetaValue, toArray, findElement, removeElement, insertAfter } from '../helpers';

export default () => ({
  dropzone: null,
  addedFiles: 0,
  completedFiles: 0,

  init() {
    this.initializeDropzone();
    this.hideFileInput();
    this.bindEvents();
    Dropzone.autoDiscover = false;
  },

  initializeDropzone() {
    this.dropzone = new Dropzone(this.$el, {
      url: this.$el.dataset.directUploadUrl,
      headers: { 'X-CSRF-Token': getMetaValue('csrf-token') },
      maxFiles: this.$el.dataset.maxFiles || 100,
      maxFilesize: this.$el.dataset.maxFileSize || 2048,
      acceptedFiles: this.$el.dataset.acceptedFiles,
      addRemoveLinks: true,
      autoQueue: false,
      dictDefaultMessage: 'Arrastra tus archivos aquí para subirlos',
      dictFallbackMessage: 'Tu navegador no soporta la carga de archivos por "arrastrar y soltar."',
      dictFallbackText: 'Por favor, utiliza el formulario para subir tus archivos.',
      dictFileTooBig: 'El archivo es muy grande ({{filesize}}MiB). Tamaño máximo: {{maxFilesize}}MiB.',
      dictInvalidFileType: 'No puedes subir archivos de este tipo.',
      dictResponseError: 'Hubo un error en la respuesta del servidor ({{statusCode}}).',
      dictCancelUpload: 'Cancelar subida',
      dictUploadCanceled: 'Subida cancelada.',
      dictCancelUploadConfirmation: '¿Estás seguro de que quieres cancelar esta subida?',
      dictRemoveFile: 'Eliminar archivo'
    });
  },

  hideFileInput() {
    const input = this.$el.querySelector('input[type="file"]');
    if (input) {
      input.disabled = true;
      input.style.display = 'none';
    }
  },

  bindEvents() {
    this.dropzone.on('addedfile', (file) => {
      setTimeout(() => {
        this.addedFiles++;
        if (file.accepted) {
          this.createDirectUploadController(file).start();
        }
      }, 500);
    });

    this.dropzone.on('removedfile', (file) => {
      this.addedFiles--;
      if (file.controller) {
        removeElement(file.controller.hiddenInput);
      }
    });

    this.dropzone.on('canceled', (file) => {
      if (file.controller) {
        file.controller.xhr.abort();
      }
    });

    this.dropzone.on('complete', () => {
      this.completedFiles++;
      if (this.completedFiles === this.addedFiles) {
        this.completedFiles = 0;
        this.addedFiles = 0;
        const input = this.$el.querySelector('input[type="file"]');
        if (input) {
          input.value = '';
          input.disabled = false;
        }
        const startButton = document.querySelector('#start-transcript-btn');
        if (startButton) {
          startButton.disabled = false;
        }
      }
    });

    const form = document.querySelector('#track-form');
    if (form) {
      form.addEventListener('submit', () => {
        setTimeout(() => {
          this.dropzone.removeAllFiles(true);
        }, 1);
      });
    }
  },

  createDirectUploadController(file) {
    return new DirectUploadController(this, file);
  }
});

class DirectUploadController {
  constructor(source, file) {
    this.directUpload = new DirectUpload(file, source.$el.dataset.directUploadUrl, this);
    this.source = source;
    this.file = file;
  }

  start() {
    this.file.controller = this;
    this.hiddenInput = this.createHiddenInput();
    this.directUpload.create((error, attributes) => {
      if (error) {
        removeElement(this.hiddenInput);
        this.emitDropzoneError(error);
      } else {
        this.hiddenInput.value = attributes.signed_id;
        this.emitDropzoneSuccess();
      }
    });
  }

  createHiddenInput() {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = this.source.$el.querySelector('input[type="file"]').name;
    insertAfter(input, this.source.$el.querySelector('input[type="file"]'));
    return input;
  }

  directUploadWillStoreFileWithXHR(xhr) {
    this.bindProgressEvent(xhr);
    this.emitDropzoneUploading();
  }

  bindProgressEvent(xhr) {
    this.xhr = xhr;
    this.xhr.upload.addEventListener('progress', (event) =>
      this.uploadRequestDidProgress(event)
    );
  }

  uploadRequestDidProgress(event) {
    const progress = (event.loaded / event.total) * 100;
    findElement(
      this.file.previewTemplate,
      '.dz-upload'
    ).style.width = `${progress}%`;
  }

  emitDropzoneUploading() {
    this.file.status = Dropzone.UPLOADING;
    this.source.dropzone.emit('processing', this.file);
  }

  emitDropzoneError(error) {
    this.file.status = Dropzone.ERROR;
    this.source.dropzone.emit('error', this.file, error);
    this.source.dropzone.emit('complete', this.file);
  }

  emitDropzoneSuccess() {
    this.file.status = Dropzone.SUCCESS;
    this.source.dropzone.emit('success', this.file);
    this.source.dropzone.emit('complete', this.file);
  }
}
